var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuissance45(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1660.47900390625,
    height: 916,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 0,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 70,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 140,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 210,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 280,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 350,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 420,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 490,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 560,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 630,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 700,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 770,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 840,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 910,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 980,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1050,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1120,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1190,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1260,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1330,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1400,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1470,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1540,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 0,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 12,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 24,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 36,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 48,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 60,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 72,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 84,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 96,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 108,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 120,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 132,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 144,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 156,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 168,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 180,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 192,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 204,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 216,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 228,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 240,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 252,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 264,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 276,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 288,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 300,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 312,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 324,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 336,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 348,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 360,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 372,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 384,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 396,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 408,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 420,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 432,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 444,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 456,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 468,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 480,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 492,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 504,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 516,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 528,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 540,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 552,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 564,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 576,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 588,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 600,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 612,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 624,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 636,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 648,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 660,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 672,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 684,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 696,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 708,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 720,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 732,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 744,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 756,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 768,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 780,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 792,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 804,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 816,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 828,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 840,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 852,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 864,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 876,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 888,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 900,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#cfcfcf",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "8px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1610,
    y: 912,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#C0C0C0",
    stroke: "none",
    x: 167,
    y: 71,
    width: 1496,
    height: 896,
    transform: "matrix(1 0 0 1 -86 -54)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    stroke: "none",
    x: 160,
    y: 64,
    width: 1496,
    height: 896,
    transform: "matrix(1 0 0 1 -86 -54)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 74 10 L 1570 10 L 1570 906 L 74 906 L 74 10 Z Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 908.5,
    y: 77.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "Puissance 4"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 27.830898437499997 371.85 C 27.830898437499997 366.96227952000004 31.7887008055 363 36.6708984375 363 C 41.5530960695 363 45.5108984375 366.96227952000004 45.5108984375 371.85 C 45.5108984375 376.73772048 41.5530960695 380.7 36.6708984375 380.7 C 31.7887008055 380.7 27.830898437499997 376.73772048 27.830898437499997 371.85 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 27.830898437499997 371.85 C 27.830898437499997 366.96227952000004 31.7887008055 363 36.6708984375 363 C 41.5530960695 363 45.5108984375 366.96227952000004 45.5108984375 371.85 C 45.5108984375 376.73772048 41.5530960695 380.7 36.6708984375 380.7 C 31.7887008055 380.7 27.830898437499997 376.73772048 27.830898437499997 371.85 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 36.6708984375 380.7 L 36.6708984375 398.3",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 27.3108984375 387.3 L 46.030898437500014 387.3",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 36.6708984375 398.3 L 23.6708984375 416",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 36.6708984375 398.3 L 49.6708984375 416",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 123.1708984375,
    y: 484.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "Joueur"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 175 226.5 C 175 216.835016 245.06742880000002 209 331.5 209 C 417.9325712 209 488 216.835016 488 226.5 C 488 236.164984 417.9325712 244 331.5 244 C 245.06742880000002 244 175 236.164984 175 226.5 Z",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 168 219.5 C 168 209.835016 238.06742880000002 202 324.5 202 C 410.9325712 202 481 209.835016 481 219.5 C 481 229.164984 410.9325712 237 324.5 237 C 238.06742880000002 237 168 229.164984 168 219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 168 219.5 C 168 209.835016 238.06742880000002 202 324.5 202 C 410.9325712 202 481 209.835016 481 219.5 C 481 229.164984 410.9325712 237 324.5 237 C 238.06742880000002 237 168 229.164984 168 219.5 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 410.5,
    y: 274.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "D\xE9marrer  une partie"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 175 492.5 C 175 482.835016 245.06742880000002 475 331.5 475 C 417.9325712 475 488 482.835016 488 492.5 C 488 502.164984 417.9325712 510 331.5 510 C 245.06742880000002 510 175 502.164984 175 492.5 Z",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 168 485.5 C 168 475.835016 238.06742880000002 468 324.5 468 C 410.9325712 468 481 475.835016 481 485.5 C 481 495.164984 410.9325712 503 324.5 503 C 238.06742880000002 503 168 495.164984 168 485.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 168 485.5 C 168 475.835016 238.06742880000002 468 324.5 468 C 410.9325712 468 481 475.835016 481 485.5 C 481 495.164984 410.9325712 503 324.5 503 C 238.06742880000002 503 168 495.164984 168 485.5 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 410.5,
    y: 540.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "Afficher les r\xE8gles du jeu"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 175 359.5 C 175 349.835016 245.06742880000002 342 331.5 342 C 417.9325712 342 488 349.835016 488 359.5 C 488 369.164984 417.9325712 377 331.5 377 C 245.06742880000002 377 175 369.164984 175 359.5 Z",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 168 352.5 C 168 342.835016 238.06742880000002 335 324.5 335 C 410.9325712 335 481 342.835016 481 352.5 C 481 362.164984 410.9325712 370 324.5 370 C 238.06742880000002 370 168 362.164984 168 352.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 168 352.5 C 168 342.835016 238.06742880000002 335 324.5 335 C 410.9325712 335 481 342.835016 481 352.5 C 481 362.164984 410.9325712 370 324.5 370 C 238.06742880000002 370 168 362.164984 168 352.5 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 410.5,
    y: 407.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "Reprendre une partie sauvegarder"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 175 625.5 C 175 615.835016 245.06742880000002 608 331.5 608 C 417.9325712 608 488 615.835016 488 625.5 C 488 635.164984 417.9325712 643 331.5 643 C 245.06742880000002 643 175 635.164984 175 625.5 Z",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 168 618.5 C 168 608.835016 238.06742880000002 601 324.5 601 C 410.9325712 601 481 608.835016 481 618.5 C 481 628.164984 410.9325712 636 324.5 636 C 238.06742880000002 636 168 628.164984 168 618.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 168 618.5 C 168 608.835016 238.06742880000002 601 324.5 601 C 410.9325712 601 481 608.835016 481 618.5 C 481 628.164984 410.9325712 636 324.5 636 C 238.06742880000002 636 168 628.164984 168 618.5 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 410.5,
    y: 673.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "Afficher le tableau des scores"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 55 361 L 122 218 L 167 218",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 64 389 L 122 362 L 167 360",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 64 428 L 124 482 L 167 483",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 55 443 L 130 610 L 167 612",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 601 66.5 C 601 56.835015999999996 643.7568016 49 696.5 49 C 749.2431984 49 792 56.835015999999996 792 66.5 C 792 76.164984 749.2431984 84 696.5 84 C 643.7568016 84 601 76.164984 601 66.5 Z",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 594 59.5 C 594 49.835015999999996 636.7568016 42 689.5 42 C 742.2431984 42 785 49.835015999999996 785 59.5 C 785 69.164984 742.2431984 77 689.5 77 C 636.7568016 77 594 69.164984 594 59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 594 59.5 C 594 49.835015999999996 636.7568016 42 689.5 42 C 742.2431984 42 785 49.835015999999996 785 59.5 C 785 69.164984 742.2431984 77 689.5 77 C 636.7568016 77 594 69.164984 594 59.5 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 775.5,
    y: 114.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "S\xE9lectionner \"jouer\""))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 617 178.5 C 617 168.835016 670.725824 161 737 161 C 803.274176 161 857 168.835016 857 178.5 C 857 188.164984 803.274176 196 737 196 C 670.725824 196 617 188.164984 617 178.5 Z",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 610 171.5 C 610 161.835016 663.725824 154 730 154 C 796.274176 154 850 161.835016 850 171.5 C 850 181.164984 796.274176 189 730 189 C 663.725824 189 610 181.164984 610 171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 610 171.5 C 610 161.835016 663.725824 154 730 154 C 796.274176 154 850 161.835016 850 171.5 C 850 181.164984 796.274176 189 730 189 C 663.725824 189 610 181.164984 610 171.5 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 816,
    y: 226.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "Entrer le nom des joueurs"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 137 66.5 C 137 56.835015999999996 237.0643472 49 360.5 49 C 483.93565279999996 49 584 56.835015999999996 584 66.5 C 584 76.164984 483.93565279999996 84 360.5 84 C 237.0643472 84 137 76.164984 137 66.5 Z",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 130 59.5 C 130 49.835015999999996 230.0643472 42 353.5 42 C 476.93565279999996 42 577 49.835015999999996 577 59.5 C 577 69.164984 476.93565279999996 77 353.5 77 C 230.0643472 77 130 69.164984 130 59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 130 59.5 C 130 49.835015999999996 230.0643472 42 353.5 42 C 476.93565279999996 42 577 49.835015999999996 577 59.5 C 577 69.164984 476.93565279999996 77 353.5 77 C 230.0643472 77 130 69.164984 130 59.5 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 439.5,
    y: 114.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "Choisir la couleur des pions pour chaque joueurs"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 601 490.5 C 601 480.835016 687.6328912 473 794.5 473 C 901.3671088 473 988 480.835016 988 490.5 C 988 500.164984 901.3671088 508 794.5 508 C 687.6328912 508 601 500.164984 601 490.5 Z",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 594 483.5 C 594 473.835016 680.6328912 466 787.5 466 C 894.3671088 466 981 473.835016 981 483.5 C 981 493.164984 894.3671088 501 787.5 501 C 680.6328912 501 594 493.164984 594 483.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 594 483.5 C 594 473.835016 680.6328912 466 787.5 466 C 894.3671088 466 981 473.835016 981 483.5 C 981 493.164984 894.3671088 501 787.5 501 C 680.6328912 501 594 493.164984 594 483.5 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 873.5,
    y: 538.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "Visualiser les r\xE8gles du jeu du puissance 4"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 641 626.5 C 641 616.835016 706.1425616 609 786.5 609 C 866.8574384 609 932 616.835016 932 626.5 C 932 636.164984 866.8574384 644 786.5 644 C 706.1425616 644 641 636.164984 641 626.5 Z",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 634 619.5 C 634 609.835016 699.1425616 602 779.5 602 C 859.8574384 602 925 609.835016 925 619.5 C 925 629.164984 859.8574384 637 779.5 637 C 699.1425616 637 634 629.164984 634 619.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 634 619.5 C 634 609.835016 699.1425616 602 779.5 602 C 859.8574384 602 925 609.835016 925 619.5 C 925 629.164984 859.8574384 637 779.5 637 C 699.1425616 637 634 629.164984 634 619.5 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 865.5,
    y: 674.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "Visualiser le tableau des scores"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 689 78 L 690 122 L 322 122 L 324 201",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 315.06926017192984 180.8942325159341 L 324 201 L 331.9019378355018 180.46808877761583"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 315.06926017192984 180.8942325159341 L 324 201 L 331.9019378355018 180.46808877761583 L 315.06926017192984 180.8942325159341",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 353 78 L 354 122 L 322 122 L 324 201",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 315.06926017192984 180.8942325159341 L 324 201 L 331.9019378355018 180.46808877761583"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 315.06926017192984 180.8942325159341 L 324 201 L 331.9019378355018 180.46808877761583 L 315.06926017192984 180.8942325159341",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 1281 362.5 C 1281 352.835016 1322.8613712 345 1374.5 345 C 1426.1386288 345 1468 352.835016 1468 362.5 C 1468 372.164984 1426.1386288 380 1374.5 380 C 1322.8613712 380 1281 372.164984 1281 362.5 Z",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 1274 355.5 C 1274 345.835016 1315.8613712 338 1367.5 338 C 1419.1386288 338 1461 345.835016 1461 355.5 C 1461 365.164984 1419.1386288 373 1367.5 373 C 1315.8613712 373 1274 365.164984 1274 355.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 1274 355.5 C 1274 345.835016 1315.8613712 338 1367.5 338 C 1419.1386288 338 1461 345.835016 1461 355.5 C 1461 365.164984 1419.1386288 373 1367.5 373 C 1315.8613712 373 1274 365.164984 1274 355.5 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 1453.5,
    y: 410.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "Jouer une partie \xE0 2"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 482 219 L 1362 218 L 1366 337",
    strokeMiterlimit: 10,
    strokeDasharray: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 1361.4514486239075 326.984478027629 L 1366 337 L 1369.865731981176 326.70164497360315",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    stroke: "none",
    x: 1450,
    y: 264,
    width: 55.65625,
    height: 13,
    transform: "matrix(1 0 0 1 -86 -54)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 1477.828125,
    y: 270.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "\xABinclude\xBB"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 482 352 L 1273 355",
    strokeMiterlimit: 10,
    strokeDasharray: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 1262.8214330468056 359.1709441112703 L 1273 355 L 1262.8533634196058 350.7519691496643",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    stroke: "none",
    x: 936,
    y: 384,
    width: 55.65625,
    height: 13,
    transform: "matrix(1 0 0 1 -86 -54)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 963.828125,
    y: 390.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "\xABinclude\xBB"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 609 185 L 476 201",
    strokeMiterlimit: 10,
    strokeDasharray: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 485.58714204739465 195.6067906249545 L 476 201 L 486.59270807536495 203.96555823245785",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    stroke: "none",
    x: 592,
    y: 223,
    width: 53.49169921875,
    height: 13,
    transform: "matrix(1 0 0 1 -86 -54)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 618.745849609375,
    y: 229.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "\xABextend\xBB"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 449 418.5 C 449 408.835016 501.606536 401 566.5 401 C 631.393464 401 684 408.835016 684 418.5 C 684 428.164984 631.393464 436 566.5 436 C 501.606536 436 449 428.164984 449 418.5 Z",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 442 411.5 C 442 401.835016 494.606536 394 559.5 394 C 624.393464 394 677 401.835016 677 411.5 C 677 421.164984 624.393464 429 559.5 429 C 494.606536 429 442 421.164984 442 411.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 442 411.5 C 442 401.835016 494.606536 394 559.5 394 C 624.393464 394 677 401.835016 677 411.5 C 677 421.164984 624.393464 429 559.5 429 C 494.606536 429 442 421.164984 442 411.5 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 645.5,
    y: 466.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "Avoir une partie en cours"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 441 411 L 322 410 L 323 371",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 330.89527770197077 391.53447320991614 L 323 371 L 314.0627391475893 391.1028696572397"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 330.89527770197077 391.53447320991614 L 323 371 L 314.0627391475893 391.1028696572397 L 330.89527770197077 391.53447320991614",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 1089 490.5 C 1089 480.835016 1125.936504 473 1171.5 473 C 1217.063496 473 1254 480.835016 1254 490.5 C 1254 500.164984 1217.063496 508 1171.5 508 C 1125.936504 508 1089 500.164984 1089 490.5 Z",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 1082 483.5 C 1082 473.835016 1118.936504 466 1164.5 466 C 1210.063496 466 1247 473.835016 1247 483.5 C 1247 493.164984 1210.063496 501 1164.5 501 C 1118.936504 501 1082 493.164984 1082 483.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 1082 483.5 C 1082 473.835016 1118.936504 466 1164.5 466 C 1210.063496 466 1247 473.835016 1247 483.5 C 1247 493.164984 1210.063496 501 1164.5 501 C 1118.936504 501 1082 493.164984 1082 483.5 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 1250.5,
    y: 538.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "Retour \xE0 l'accueil"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 1081 483 L 982 483",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 1002.3253497152482 474.580964487968 L 982 483 L 1002.3253497152482 491.419035512032"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 1002.3253497152482 474.580964487968 L 982 483 L 1002.3253497152482 491.419035512032 L 1002.3253497152482 474.580964487968",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 1089 626.5 C 1089 616.835016 1125.936504 609 1171.5 609 C 1217.063496 609 1254 616.835016 1254 626.5 C 1254 636.164984 1217.063496 644 1171.5 644 C 1125.936504 644 1089 636.164984 1089 626.5 Z",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 1082 619.5 C 1082 609.835016 1118.936504 602 1164.5 602 C 1210.063496 602 1247 609.835016 1247 619.5 C 1247 629.164984 1210.063496 637 1164.5 637 C 1118.936504 637 1082 629.164984 1082 619.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 1082 619.5 C 1082 609.835016 1118.936504 602 1164.5 602 C 1210.063496 602 1247 609.835016 1247 619.5 C 1247 629.164984 1210.063496 637 1164.5 637 C 1118.936504 637 1082 629.164984 1082 619.5 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 1250.5,
    y: 674.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "Retour \xE0 l'accueil"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 1081 619 L 926 619",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 946.3253497152482 610.580964487968 L 926 619 L 946.3253497152482 627.419035512032"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 946.3253497152482 610.580964487968 L 926 619 L 946.3253497152482 627.419035512032 L 946.3253497152482 610.580964487968",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 169 778.5 C 169 768.835016 241.75372 761 331.5 761 C 421.24628 761 494 768.835016 494 778.5 C 494 788.164984 421.24628 796 331.5 796 C 241.75372 796 169 788.164984 169 778.5 Z",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 162 771.5 C 162 761.835016 234.75372 754 324.5 754 C 414.24628 754 487 761.835016 487 771.5 C 487 781.164984 414.24628 789 324.5 789 C 234.75372 789 162 781.164984 162 771.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 162 771.5 C 162 761.835016 234.75372 754 324.5 754 C 414.24628 754 487 761.835016 487 771.5 C 487 781.164984 414.24628 789 324.5 789 C 234.75372 789 162 781.164984 162 771.5 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 410.5,
    y: 826.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "D\xE9marrer une partie d'entrainement"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 153 858.5 C 153 848.835016 231.1263024 841 327.5 841 C 423.8736976 841 502 848.835016 502 858.5 C 502 868.164984 423.8736976 876 327.5 876 C 231.1263024 876 153 868.164984 153 858.5 Z",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 146 851.5 C 146 841.835016 224.1263024 834 320.5 834 C 416.8736976 834 495 841.835016 495 851.5 C 495 861.164984 416.8736976 869 320.5 869 C 224.1263024 869 146 861.164984 146 851.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 146 851.5 C 146 841.835016 224.1263024 834 320.5 834 C 416.8736976 834 495 841.835016 495 851.5 C 495 861.164984 416.8736976 869 320.5 869 C 224.1263024 869 146 861.164984 146 851.5 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 406.5,
    y: 906.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "Choisir la couleur des pions du joueur"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 529 858.5 C 529 848.835016 571.7568016 841 624.5 841 C 677.2431984 841 720 848.835016 720 858.5 C 720 868.164984 677.2431984 876 624.5 876 C 571.7568016 876 529 868.164984 529 858.5 Z",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 522 851.5 C 522 841.835016 564.7568016 834 617.5 834 C 670.2431984 834 713 841.835016 713 851.5 C 713 861.164984 670.2431984 869 617.5 869 C 564.7568016 869 522 861.164984 522 851.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 522 851.5 C 522 841.835016 564.7568016 834 617.5 834 C 670.2431984 834 713 841.835016 713 851.5 C 713 861.164984 670.2431984 869 617.5 869 C 564.7568016 869 522 861.164984 522 851.5 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 703.5,
    y: 906.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "S\xE9lectionner \"jouer\""))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 321 833 L 323 790",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 330.46559948827456 810.6945602582098 L 323 790 L 313.645712131528 809.9122399160356"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 330.46559948827456 810.6945602582098 L 323 790 L 313.645712131528 809.9122399160356 L 330.46559948827456 810.6945602582098",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 618 833 L 618 818 L 322 818 L 323 790",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 330.68822852062044 810.6128877699055 L 323 790 L 313.8608858003051 810.0119112441799"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 330.68822852062044 810.6128877699055 L 323 790 L 313.8608858003051 810.0119112441799 L 330.68822852062044 810.6128877699055",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 46 443 L 130 770 L 161 770",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 537 738.5 C 537 728.835016 586.4725296 721 647.5 721 C 708.5274704 721 758 728.835016 758 738.5 C 758 748.164984 708.5274704 756 647.5 756 C 586.4725296 756 537 748.164984 537 738.5 Z",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 530 731.5 C 530 721.835016 579.4725296 714 640.5 714 C 701.5274704 714 751 721.835016 751 731.5 C 751 741.164984 701.5274704 749 640.5 749 C 579.4725296 749 530 741.164984 530 731.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 530 731.5 C 530 721.835016 579.4725296 714 640.5 714 C 701.5274704 714 751 721.835016 751 731.5 C 751 741.164984 701.5274704 749 640.5 749 C 579.4725296 749 530 741.164984 530 731.5 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 726.5,
    y: 786.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "Entrer le nom du joueur"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 529 745 L 466 753",
    strokeMiterlimit: 10,
    strokeDasharray: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 475.5514326064058 747.5437984673138 L 466 753 L 476.61199986931877 755.895765662753",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    stroke: "none",
    x: 536,
    y: 783,
    width: 53.49169921875,
    height: 13,
    transform: "matrix(1 0 0 1 -86 -54)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 562.745849609375,
    y: 789.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "\xABextend\xBB"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 1225 778.5 C 1225 768.835016 1290.5902768 761 1371.5 761 C 1452.4097232 761 1518 768.835016 1518 778.5 C 1518 788.164984 1452.4097232 796 1371.5 796 C 1290.5902768 796 1225 788.164984 1225 778.5 Z",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 1218 771.5 C 1218 761.835016 1283.5902768 754 1364.5 754 C 1445.4097232 754 1511 761.835016 1511 771.5 C 1511 781.164984 1445.4097232 789 1364.5 789 C 1283.5902768 789 1218 781.164984 1218 771.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 1218 771.5 C 1218 761.835016 1283.5902768 754 1364.5 754 C 1445.4097232 754 1511 761.835016 1511 771.5 C 1511 781.164984 1445.4097232 789 1364.5 789 C 1283.5902768 789 1218 781.164984 1218 771.5 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 1450.5,
    y: 826.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "Jouer une partie d'entrainement"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 488 771 L 1217 771",
    strokeMiterlimit: 10,
    strokeDasharray: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 1206.837325142376 775.209517756016 L 1217 771 L 1206.837325142376 766.790482243984",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    stroke: "none",
    x: 911,
    y: 831,
    width: 55.65625,
    height: 13,
    transform: "matrix(1 0 0 1 -86 -54)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 938.828125,
    y: 837.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "\xABinclude\xBB"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 1608.899501953125 611.85 C 1608.899501953125 606.96227952 1612.857304321125 603 1617.739501953125 603 C 1622.621699585125 603 1626.579501953125 606.96227952 1626.579501953125 611.85 C 1626.579501953125 616.73772048 1622.621699585125 620.7 1617.739501953125 620.7 C 1612.857304321125 620.7 1608.899501953125 616.73772048 1608.899501953125 611.85 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 1608.899501953125 611.85 C 1608.899501953125 606.96227952 1612.857304321125 603 1617.739501953125 603 C 1622.621699585125 603 1626.579501953125 606.96227952 1626.579501953125 611.85 C 1626.579501953125 616.73772048 1622.621699585125 620.7 1617.739501953125 620.7 C 1612.857304321125 620.7 1608.899501953125 616.73772048 1608.899501953125 611.85 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 1617.739501953125 620.7 L 1617.739501953125 638.3",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 1608.379501953125 627.3 L 1627.099501953125 627.3",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 1617.739501953125 638.3 L 1604.739501953125 656",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 1617.739501953125 638.3 L 1630.739501953125 656",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 1704.239501953125,
    y: 724.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "Syst\xE8me"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 1399 753 L 1585 658",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 482 484 L 593 484",
    strokeMiterlimit: 10,
    strokeDasharray: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 582.8373251423759 488.209517756016 L 593 484 L 582.8373251423758 479.790482243984",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    stroke: "none",
    x: 592,
    y: 511,
    width: 55.65625,
    height: 13,
    transform: "matrix(1 0 0 1 -86 -54)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 619.828125,
    y: 517.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "\xABinclude\xBB"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 482 618 L 633 619",
    strokeMiterlimit: 10,
    strokeDasharray: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 622.8096710012187 623.1421244424326 L 633 619 L 622.8654249806772 614.7232735442025",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    stroke: "none",
    x: 608,
    y: 647,
    width: 55.65625,
    height: 13,
    transform: "matrix(1 0 0 1 -86 -54)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "undefined",
    x: 635.828125,
    y: 653.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "\xABinclude\xBB"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0C0",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 769 858.5 C 769 848.835016 833.2471312 841 912.5 841 C 991.7528688 841 1056 848.835016 1056 858.5 C 1056 868.164984 991.7528688 876 912.5 876 C 833.2471312 876 769 868.164984 769 858.5 Z",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 762 851.5 C 762 841.835016 826.2471312 834 905.5 834 C 984.7528688 834 1049 841.835016 1049 851.5 C 1049 861.164984 984.7528688 869 905.5 869 C 826.2471312 869 762 861.164984 762 851.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 762 851.5 C 762 841.835016 826.2471312 834 905.5 834 C 984.7528688 834 1049 841.835016 1049 851.5 C 1049 861.164984 984.7528688 869 905.5 869 C 826.2471312 869 762 861.164984 762 851.5 Z",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "bold",
    textDecoration: "undefined",
    x: 991.5,
    y: 906.5,
    textAnchor: "middle",
    dominantBaseline: "central",
    transform: "matrix(1 0 0 1 -86 -54)"
  }, "S\xE9lectionner le niveau du robot"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 906 833 L 906 818 L 322 818 L 323 790",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: " M 330.68822852062044 810.6128877699055 L 323 790 L 313.8608858003051 810.0119112441799"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    paintOrder: "fill stroke markers",
    d: " M 330.68822852062044 810.6128877699055 L 323 790 L 313.8608858003051 810.0119112441799 L 330.68822852062044 810.6128877699055",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuissance45);
export default __webpack_public_path__ + "static/media/Puissance4_5.d24adf15116317ae2d9727351d763155.svg";
export { ForwardRef as ReactComponent };